import { Currency, FormatType } from 'api';
import { GetState, SetState } from 'zustand';
import { AppState } from './appstate';

type Get = GetState<AppState>;
type Set = SetState<AppState>;

export const setDepth = (depth: number, get: Get, set: Set) => {
  const depthsWidths = get().styleProduct.style!.depths.find(
    (d) => d.depth.value === depth
  );
  if (!depthsWidths) {
    throw new Error('depth does not exist on object');
  }
  if (!depthsWidths.widths[0]) {
    throw new Error('no widths exist for depth');
  }
  const isCurrentWidthInNewList = depthsWidths.widths.find(({value}) => value === get().uState?.dimensions.width);
  const width = isCurrentWidthInNewList ? {} : { width: depthsWidths.widths[0].value };
  set((state: AppState) => {
    return {
      uState: {
        ...state.uState!,
        dimensions: {
          ...state.uState!.dimensions,
          depth: depthsWidths.depth.value,
          ...width,
        },
      },
    };
  });
};

export const setWidth = (width: number, get: Get, set: Set) => {
  const depths = get().styleProduct.style?.depths.find(
    (d) => d.depth.value === get().uState?.dimensions.depth
  );
  if (!depths) {
    throw new Error('no depths found');
  }
  const newWidth = depths.widths.find((w) => w.value === width);
  if (!newWidth) {
    throw new Error('tried to set invalid width');
  }
  set((state: AppState) => {
    return {
      uState: {
        ...state.uState!,
        dimensions: {
          ...state.uState!.dimensions,
          width: newWidth.value,
        },
      },
    };
  });
};

export const setWallHeight = (wallHeight: number, get: Get, set: Set) => {
  const newHeight = get().styleProduct.style?.wallHeights.find(
    (h) => wallHeight === h.value
  );
  if (!newHeight) {
    throw new Error('tried to set invalid wallheight');
  }
  set((state: AppState) => {
    return {
      uState: {
        ...state.uState!,
        dimensions: {
          ...state.uState!.dimensions,
          wallHeight: newHeight.value,
        },
      },
    };
  });
};

export const setOverhang = (overhang: number, get: Get, set: Set) => {
  const newOverhang = get().styleProduct.style?.overhangs.find(
    (o) => overhang === o.value
  );
  if (!newOverhang) {
    throw new Error('tried to set invalid overhang');
  }
  set((state: AppState) => {
    return {
      uState: {
        ...state.uState!,
        overhang: newOverhang.value,
      },
    };
  });
};

export const setFormat = (format: FormatType, get: Get, set: Set) => {
  if (!Object.values(FormatType).includes(format)) {
    throw new Error('attempted to set invalid format');
  }
  set((state: AppState) => ({
    uState: {
      ...state.uState!,
      format,
    },
  }));
};

export const setCurrency = (currency: Currency, get: Get, set: Set) => {
  if (!Object.values(Currency).includes(currency)) {
    throw new Error('attempted to set invalid currency');
  }
  set((state: AppState) => ({
    uState: { ...state.uState!, currency },
  }));
};
